import { adaptToDatabase } from '../../../utils/adaptToDatabase'
import apinode from '../../apinode'

class ProdutosService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll(search) {
    const response = await apinode.get(
      `/produtos/${this.idconta}?search=${search}`,
    )

    if (response.data.length === 1) {
      return response.data[0]
    }

    return response.data
  }

  async getById(id) {
    const response = await apinode.get(`/produtos/find/${this.idconta}/${id}`)

    return response.data
  }

  async getBySKU(sku) {
    const response = await apinode.get(`/produtos/sku/${sku}/${this.idconta}`)

    return response.data
  }

  async getAllToAdjust(conta, search) {
    const response = await apinode.get(
      `/produtos/adjust/${conta}?search=${search}`,
    )

    return response.data
  }

  async getAllToTransfer(conta, search) {
    const response = await apinode.get(
      `/produtos/transfer/${conta}?search=${search}`,
    )

    return response.data
  }

  async create(data) {
    const decimalFields = [
      'PRECOCUSTO',
      'PRECOVENDA',
      'PRECOATACADO',
      'PRECOATACADO_P',
      'PRECOVAREJO_P',
      'ESTOQUEMINIMO',
    ]

    const dataFormatted = adaptToDatabase(
      { ...data, iduser: localStorage.idusuario },
      decimalFields,
    )

    const response = await apinode.post(`/produtos/${this.idconta}`, {
      ...dataFormatted,
    })

    return response.data
  }

  async getRelatoriosEstoqueMinimo() {
    const response = await apinode.get(
      `/produtos/relatorios/estoque-minimo/${this.idconta}`,
    )

    return response.data
  }

  async importProduct(sku) {
    const response = await apinode.post(
      `/produtos/import/${sku}/${this.idconta}`,
    )

    return response.data.codproduto
  }

  async update(id, data) {
    const decimalFields = [
      'PRECOCUSTO',
      'PRECOVENDA',
      'PRECOATACADO',
      'PRECOATACADO_P',
      'PRECOVAREJO_P',
      'ESTOQUEMINIMO',
    ]

    const dataFormatted = adaptToDatabase(
      { ...data, iduser: localStorage.idusuario },
      decimalFields,
    )

    await apinode.put(`/produtos/${this.idconta}/${id}`, { ...dataFormatted })
  }

  async updatePrices(
    id,
    { precocusto, precovenda, precoatacado, precovarejo_p, precoatacado_p },
  ) {
    const data = {
      precocusto,
      precovenda,
      precoatacado,
      precovarejo_p,
      precoatacado_p,
    }

    const dataFormatted = adaptToDatabase(data, [
      'precocusto',
      'precovenda',
      'precoatacado',
      'precovarejo_p',
      'precoatacado_p',
    ])

    await apinode.patch(`/produtos/prices/${id}/${this.idconta}`, dataFormatted)
  }

  async transferStock({ bancoSaida, bancoEntrada, selectedProducts }) {
    const response = await apinode.patch('/produtos/transfer-stock', {
      bancoSaida,
      bancoEntrada,
      selectedProducts,
    })

    return response.data
  }

  async updateStock({ type, reason, selectedProducts }) {
    const response = await apinode.patch(
      `/produtos/${this.idconta}/update-stock`,
      {
        type,
        reason,
        selectedProducts,
      },
    )

    return response.data
  }
}

export default new ProdutosService()
